import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class СolorSlider {
    #wrapEl;
    #swiperEl;
    #slider;
    #cssVarName;
    #selectedColor;
    #options;
    #colors;

    constructor(wrapEl, options = {
        initialSlide: 0
    }) {
        this.#wrapEl = wrapEl;
        this.#swiperEl = this.#wrapEl.querySelector('.swiper');
        this.#cssVarName = this.#wrapEl.dataset.cssVar;
        this.#options = options;

        this.getColors();
        this.initSlider();

        this.selectColor(this.#colors[this.#options.initialSlide]);
    }

    getColors() {
        this.#colors = Array.from(this.#swiperEl.querySelectorAll('.swiper-slide')).reduce((result, el) => {
            const { color } = el.dataset;

            return [...result, color];
        }, []);
    }

    selectColor(color) {
        this.#selectedColor = color;
        document.documentElement.style.setProperty(`--${this.#cssVarName}`, color);
    }

    initSlider() {
        this.#slider = new Swiper(this.#swiperEl, {
            modules: [Navigation],
            direction: 'horizontal',
            slidesPerView: 1,
            initialSlide: this.#options.initialSlide,
            loop: true,
            navigation: {
                prevEl: this.#wrapEl.querySelector('.js-color-slider-arrow-next'),
                nextEl: this.#wrapEl.querySelector('.js-color-slider-arrow-prev')
            },
            breakpoints: {
                '@1.5': {
                    direction: 'vertical'
                }
            },
            on: {
                realIndexChange: (swiper) => {
                    const color = this.#colors[swiper.realIndex];

                    this.selectColor(color);
                }
            }
        });
    }
}
